// const base = process.env.VUE_APP_URL
import axios from "axios";
import { ir } from "../check_domain_ir";

const base = ir("https://ai-api.terminalads.com");
const api = axios.create({
  baseURL: base,
  headers: {
    Authorization: localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  },
});

export class DesignImage {
  constructor(image) {
    this.file = image;
  }

  removeBg() {
    const form_data = new FormData();

    form_data.append("image", this.file);

    return new Promise((resolve, reject) => {
      api
        .post("/api/image/remove/back/v2", form_data)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  generatePixlr(prompt) {
    return new Promise((resolve, reject) => {
      api
        .post("/api/image/generate/image", {
          amount: 1,
          height: 1024,
          width: 1024,
          prompt,
        })
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  translatePrompt(prompt) {
    return new Promise((resolve, reject) => {
      api
        .post(this.$aiApi + "/image/translate", {
          // .post("https://ai-api.terminalads.com/api/image/translate", {
          // format: "text",
          // from: "per",
          // to: "eng",
          // input: prompt.replace(/\n/g, " "),
          // options: {
          //   sentenceSplitter: true,
          //   origin: "core-ai.terminalads.com",
          //   contextResults: true,
          //   languageDetection: true,
          // },
          text: prompt.replace(/\n/g, " "),
          from: "fa",
          to: "en",
        })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
        });
    });
  }

  getDefaultBackgrounds() {
    return new Promise((resolve, reject) => {
      api
        .get("/api/readfile")
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }
}
